import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import InputWrapper from "../../../layout/inputWrapper";
import ButtonWrapper from "../../../components/Button";



const SubStep5 = ({ formData, handleTabChange, handleSubTabChange}) => {
    const { t } = useTranslation();
    const defaultValues = {
        ...formData,
    };
    const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({defaultValues});
    const onSubmit = (data) => {
        handleTabChange(1, data)
    };
    return (
        <section className="groupContainer">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer">
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">
                            Bank Information(In case of Refund)
                        </h2>
                    </div>
                    <div className="formInputContainer">
                        <div className="columnWrapper">
                            <InputWrapper
                                label="Account holder Name"
                                control={control}
                                placeholder="Enter Account holder Name"
                                defaultValue={formData?.landInfo?.bankdetails?.accountHolderName}
                                name={`landInfo.bankdetails.accountHolderName`}
                                type="textInput"
                                maxLength={30}
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                    pattern: {
                                        value: Digit.Utils.getPattern("Name"),
                                        message: "Please enter only letters and spaces",
                                    },
                                }}
                            />
                            <InputWrapper
                                label="Branch Name"
                                control={control}
                                placeholder="Enter Branch Name"
                                defaultValue={formData?.landInfo?.bankdetails?.branchName}
                                name={`landInfo.bankdetails.branchName`}
                                type="textInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                }}
                            />
                            <InputWrapper
                                label="IFSC Code"
                                control={control}
                                placeholder="Enter IFSC Code"
                                defaultValue={formData?.landInfo?.bankdetails?.ifscCode}
                                name={`landInfo.bankdetails.ifscCode`}
                                type="textInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                }}
                            />
                        </div>
                        <div className="columnWrapper">
                            <InputWrapper
                                label="Account No."
                                control={control}
                                placeholder="Enter Account No."
                                defaultValue={formData?.landInfo?.bankdetails?.accountNo}
                                name={`landInfo.bankdetails.accountNo`}
                                type="textInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    }
                                }}
                            />
                            <InputWrapper
                                label={t("LABEL_BANK_NAME")}
                                control={control}
                                placeholder={t("LABEL_ENTER_BANK_NAME")}
                                defaultValue={formData?.landInfo?.bankdetails?.bankName}
                                name={`landInfo.bankdetails.bankName`}
                                type="textInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required",
                                    },
                                }}
                            />
                        </div>
                        <br />
                    </div>
                </div>
                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Prev"
                            sx={{ backgroundColor: '#CCC' }}
                            onClick={() => handleSubTabChange(3)}
                        />
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Save"
                            type="submit"
                            sx={{ backgroundColor: '#157CB3' }}
                        />
                    </div>
                </div>
            </form>

        </section>
    );
};

export default SubStep5;
